import type { LoaderFunction } from 'react-router';

import type { RouteProps } from '../../../shared/RouteProps';
import type { SalariesModel } from './salariesModel';

export const salariesLoader =
  ({ services, logger }: RouteProps): LoaderFunction =>
  async ({ params, request }): Promise<SalariesModel> => {
    return {
      test: 'this is a temp content setup for salaries page',
    };
  };
